import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import { register } from './sw-register'
import { isAppPath } from './routes.mjs'

function startApp() {
  createRoot(document.getElementById('root')).render(<App />)
  // A join or script link pasted into the address bar of an open tab only changes the hash: reload so it opens.
  window.addEventListener('hashchange', () => { if (/^#(J\/|O\/|join=|s=)/i.test(window.location.hash)) window.location.reload() })
  register()
}

// npm start: website pages come from the same list the build prerenders.
// (This branch is removed from production builds.)
if (process.env.NODE_ENV === 'development' && !isAppPath(window.location.pathname)) {
  Promise.all([import('./landing/site.mjs'), import('./core/landing/devlanding')])
    .then(([site, { devLanding }]) => { if (!devLanding(site, isAppPath)) startApp() })
    .catch((e) => { console.warn('website preview failed', e); startApp() })
} else startApp()
